"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LuxuryLevelWindowCleaning() {
  const [offsetY, setOffsetY] = useState(0);
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY * 0.15);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="222204" id="luxury-level-window-cleaning" className="bg-background text-foreground relative overflow-hidden min-h-screen w-full flex flex-col lg:flex-row">
      {}
      <div className="relative w-full lg:w-[55%] h-[60vh] lg:h-screen overflow-hidden shrink-0">
        <div className="absolute inset-0 w-full h-[120%] -top-[10%]" style={{
        transform: `translateY(${offsetY}px)`,
        transition: "transform 0.1s ease-out"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/luxury_gta_estate_reflection.png" alt="Luxury GTA estate reflecting the skyline in pristine windows" className="w-full h-full object-cover object-center" />
        </div>

        {}
        <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,transparent_40%,rgba(255,255,255,0.05)_100%)] mix-blend-overlay"></div>
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-background via-background/40 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-background/50 lg:to-background"></div>
      </div>

      {}
      <div className="relative w-full lg:w-[45%] flex items-center justify-center p-8 lg:p-16 z-10 -mt-20 lg:mt-0">
        <div ref={contentRef} className={`max-w-xl flex flex-col items-center lg:items-start text-center lg:text-left transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-default text-6xl md:text-8xl lg:text-[80px] font-bold tracking-tighter bg-gradient-to-b from-white to-zinc-400 bg-clip-text text-transparent leading-none mb-6">
            LUXURY LEVEL WINDOW CLEANING
          </h1>
          
          <p className="text-muted-foreground font-default text-lg md:text-xl leading-relaxed mb-10 max-w-md">
            Guaranteed perfection for the GTA's most prestigious homes. Experience the clarity of 6SPC.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto rounded-md bg-primary text-primary-foreground hover:bg-zinc-200 transition-colors shadow-lg">
              <Link to="/QuoteCalculatorPage">
                Get a Free Quote
                <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>
            
            <Button asChild variant="link" size="lg" className="w-full sm:w-auto text-zinc-400 hover:text-white border border-zinc-700 rounded-md px-8">
              <Link to="/ExperiencePage">
                Our Process
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}